import {z} from 'zod';

import {isNil} from 'ramda';

import {ScopeValues} from '@dms/api/shared';

export const evaluateServiceCaseType = (scopes: string[], evaluatorParams: ScopeValues) => {
  const {serviceCaseType} = validateServiceCaseEvaluatorParams(evaluatorParams);

  if (serviceCaseType === 'SKIP') {
    return true;
  }

  if (isNil(serviceCaseType)) {
    return false;
  }

  return scopes.includes(serviceCaseType);
};

// export only for testing purposes
export const validateServiceCaseEvaluatorParams = (evaluatorParams: ScopeValues | null) =>
  serviceCaseParamsSchema.parse(evaluatorParams);

const serviceCaseParamsSchema = z.object({
  serviceCaseType: z.string().nullable(),
});
